/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.5.25
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function PhotographFromJSON(json) {
    return PhotographFromJSONTyped(json, false);
}
export function PhotographFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'photoId': !exists(json, 'photoId') ? undefined : json['photoId'],
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'assetId': !exists(json, 'assetId') ? undefined : json['assetId'],
        'photoDate': !exists(json, 'photoDate') ? undefined : (json['photoDate'] === null ? null : new Date(json['photoDate'])),
        'photoBy': !exists(json, 'photoBy') ? undefined : json['photoBy'],
        'userType': !exists(json, 'userType') ? undefined : json['userType'],
        'photo': !exists(json, 'photo') ? undefined : json['photo'],
        'photoDescription': !exists(json, 'photoDescription') ? undefined : json['photoDescription'],
        'latitude': !exists(json, 'latitude') ? undefined : json['latitude'],
        'longitude': !exists(json, 'longitude') ? undefined : json['longitude'],
        'creationTimestamp': !exists(json, 'creationTimestamp') ? undefined : (new Date(json['creationTimestamp'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'modificationTimestamp': !exists(json, 'modificationTimestamp') ? undefined : (json['modificationTimestamp'] === null ? null : new Date(json['modificationTimestamp'])),
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : json['modifiedBy'],
    };
}
export function PhotographToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'photoId': value.photoId,
        'workorderId': value.workorderId,
        'assetId': value.assetId,
        'photoDate': value.photoDate === undefined ? undefined : (value.photoDate === null ? null : value.photoDate.toISOString()),
        'photoBy': value.photoBy,
        'userType': value.userType,
        'photo': value.photo,
        'photoDescription': value.photoDescription,
        'latitude': value.latitude,
        'longitude': value.longitude,
        'creationTimestamp': value.creationTimestamp === undefined ? undefined : (value.creationTimestamp.toISOString()),
        'createdBy': value.createdBy,
        'modificationTimestamp': value.modificationTimestamp === undefined ? undefined : (value.modificationTimestamp === null ? null : value.modificationTimestamp.toISOString()),
        'modifiedBy': value.modifiedBy,
    };
}
